"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const helpers_1 = require("./helpers");
const components_1 = require("../components");
/**
 * Creates a new recall HOC that can be easily composed.
 * @param options The options for setting up the recall.
 * @returns The HOC used for putting the component in a recall.
 */
function createRecall(options) {
    return Component => withRecall(Component, options);
}
exports.createRecall = createRecall;
/**
 * Places a component inside a recall. The component is rendered once the recall
 * state is changed.
 * @param Component The component to render when the recall state changes.
 * @param options The options for setting up the recall.
 */
function withRecall(Component, options) {
    const Wrapper = props => (React.createElement(components_1.ArbiterRecall, Object.assign({}, options), (loaded, modules, error) => React.createElement(Component, Object.assign({ loaded: loaded, modules: modules, error: error }, props))));
    Wrapper.displayName = `WithRecall(${helpers_1.getDisplayName(Component)})`;
    return Wrapper;
}
exports.withRecall = withRecall;
